import { Link } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  IconButton,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import SchoolIcon from '@mui/icons-material/School';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { LoginHeaderProps } from './types';
import { APP_VERSION } from '../../constants/version';

export function LoginHeader({ onBackToHome }: LoginHeaderProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>
      {isMobile ? (
        <IconButton
          component={Link}
          to="/"
          onClick={onBackToHome}
          sx={{
            position: 'absolute',
            top: 16,
            left: 16,
            color: 'text.secondary',
            '&:hover': {
              color: 'primary.main',
            },
          }}
        >
          <ArrowBackIcon />
        </IconButton>
      ) : (
        <Button
          component={Link}
          to="/"
          startIcon={<ArrowBackIcon />}
          onClick={onBackToHome}
          sx={{
            position: 'absolute',
            top: 24,
            left: 24,
            color: 'text.secondary',
            '&:hover': {
              color: 'primary.main',
            },
          }}
        >
          Back to Home
        </Button>
      )}
      {/* Accent pill */}
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.75,
          px: 1.5,
          py: 0.5,
          mb: 2,
          mt: isMobile ? 6 : 3,
          borderRadius: 99,
          background: (t) => alpha(t.palette.primary.main, 0.1),
          border: (t) => `1px solid ${alpha(t.palette.primary.main, 0.2)}`,
        }}
      >
        <Typography variant="caption" sx={{ color: 'primary.main', fontWeight: 600, letterSpacing: 0.5 }}>
          ✦ AI-Powered Learning
        </Typography>
      </Box>

      {/* Icon orb + title */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          mb: 1,
        }}
      >
        <Box
          sx={{
            width: 52,
            height: 52,
            borderRadius: '50%',
            background: (t) => `linear-gradient(135deg, ${t.palette.primary.main}, ${t.palette.primary.dark})`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            boxShadow: [
              `0 8px 24px ${alpha(theme.palette.primary.main, 0.45)}`,
              `inset 0 2px 0 ${alpha(theme.palette.common.white, 0.25)}`,
              `inset 0 -2px 0 ${alpha(theme.palette.common.black, 0.15)}`,
            ].join(', '),
          }}
        >
          <SchoolIcon sx={{ fontSize: 28, color: 'primary.contrastText' }} />
        </Box>
        <Box>
          <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.75 }}>
            <Typography
              variant="h4"
              component="h1"
              sx={{ color: 'text.primary', fontWeight: 700, lineHeight: 1 }}
            >
              BrainLoop
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {APP_VERSION}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Typography variant="body1" color="text.secondary" sx={{ mb: 1 }}>
        Sign in to continue your learning journey
      </Typography>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          mt: 1,
        }}
      >
      </Box>
    </>
  );
} 